import React, { useState } from "react";
import AgentDeposits from "./AgentDeposits";
import "./UserAccountTransfers.scss";
import LocalTransfers from "./LocalTransfers";
import ClaimLocalTransferse from "./ClaimLocalTransfers";
import InternalTransfers from "./InternalTransfers";
import Fees from "./Fees";
import Withdrawal from "./Withdrawal";
import InternationalTransfers from "./InternationalTransfers/InternationalTransfers";

function UserAccountTransfers({ selectedUserData }) {
  const [selectedTransferType, setSelectedTransferType] = useState("");

  const handleSelectChange = (event) => {
    setSelectedTransferType(event.target.value);
  };

  const renderTransferComponent = () => {
    switch (selectedTransferType) {
      case "sendlocal":
        return <LocalTransfers selectedUserData={selectedUserData} />;
      case "claimlocal":
        return <ClaimLocalTransferse />;
      case "deposits":
        return <AgentDeposits />;
      case "internal":
        return <InternalTransfers />;
      case "fees":
        return <Fees />;
      case "withdrawal":
        return <Withdrawal />;
      case "international":
        return <InternationalTransfers />;
      default:
        return <div>Please select a transfer type.</div>;
    }
  };

  return (
    <div>
      <select
        onChange={handleSelectChange}
        value={selectedTransferType}
        className="base-select"
      >
        <option value="">Select Transfer Type</option>
        <option value="deposits">Deposit</option>
        <option value="withdrawal">Withdrawal</option>
        <option value="sendlocal">Transfer - Send Local</option>
        <option value="claimlocal">Transfer - Claim Local</option>
        <option value="international">Transfer - International</option>
        <option value="internal">Internal Transfers</option>
        <option value="fees">Fees</option>
      </select>
      <div className="transfer-container">{renderTransferComponent()}</div>
    </div>
  );
}

export default UserAccountTransfers;
